import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Tilbudsdetaljer',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Angiv det kvalificerende forbrug og rabat i %',
      qualifying_criteria: {
        title: 'Minimumsforbrug',
        description: 'Angiv det kvalificerende forbrugsbeløb',
      },
      details: {
        title: 'Rabat i %',
        description: 'Angiv den rabat, kunderne får på deres ordre',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Angiv det kvalificerende varebeløb og rabat i %',
      qualifying_criteria: {
        title: 'Rabatterede varer',
        description: 'Vælg de varer, du tilbyder rabat på.',
      },
      details: {
        title: 'Rabat i %',
        description: 'Angiv den rabat, kunderne får på deres ordre',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Angiv de kvalificerende varer og rabat i {{currency}}',
      qualifying_criteria: {
        title: 'Rabatterede varer',
        description: 'Vælg de varer, du tilbyder rabat på.',
      },
      details: {
        title: 'Rabat i {{currency}}',
        description: 'Angiv den rabat, kunderne får på deres ordre',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Angiv det kvalificerende forbrug og rabat i {{currency}}',
      qualifying_criteria: {
        title: 'Minimumsforbrug',
        description: 'Angiv det kvalificerende forbrugsbeløb',
      },
      details: {
        title: 'Rabat i {{currency}}',
        description: 'Angiv den rabat, kunderne får på deres ordre',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Angiv det kvalificerende forbrug og gratis varer',
      qualifying_criteria: {
        title: 'Minimumsforbrug',
        description: 'Angiv det beløb, kunden skal bruge for at få den gratis vare.',
      },
      details: {
        title: 'Gratis varer:',
        description: 'Vælg den eller de gratis varer, som kunden kan vælge én af.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Vælg betingelserne i tilbuddet',
      qualifying_criteria: {
        title: 'Kvalificerende varer',
        description: 'Vælg de varer, kunden skal bestille for at få den gratis vare.',
      },
      details: {
        title: 'Gratis varer:',
        description: 'Vælg den eller de gratis varer, som kunden kan vælge én af.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Vælg betingelserne i tilbuddet',
      qualifying_criteria: {
        title: 'Kvalificerende varer',
        description: 'Vælg den kategori, kunden skal vælge fra for at få en gratis vare.',
      },
      details: {
        title: 'Gratis vare',
        description:
          'Kunderne kan vælge deres anden vare blandt de kvalificerende varer, du har valgt. Kunden får den billigste af de to varer gratis.',
      },
    },
  },
};
